// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from '/Users/xiaotang/Desktop/项目/直播项目/直播后台/src/models/user';

export const models = {
model_1: { namespace: 'user', model: model_1 },
} as const
